// extracted by mini-css-extract-plugin
export default {"emptyStates":"emptyStates_emptyStates__ayBgD","subHeader":"emptyStates_subHeader__8NYdw","pageWrapper":"emptyStates_pageWrapper__e1+tw","heading":"emptyStates_heading__2NplO"};